import { default as addressDetails } from './addressDetails';
import { default as obfuscation } from './obfuscation';
import { default as details } from './details';
import onCheckoutSecondCoownerLastNameChange from './onCheckoutSecondCoownerLastNameChange';
import onCheckoutSecondCoownerNameChange from './onCheckoutSecondCoownerNameChange';

export const secondCoowner = {
  ...addressDetails,
  ...obfuscation,
  ...details,
  ...onCheckoutSecondCoownerLastNameChange,
  ...onCheckoutSecondCoownerNameChange,
};
